// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tooltip__content[data-v-217ac0b1]{background:#fff;color:#000;opacity:1!important}.v-data-table>.v-data-table__wrapper>table>tbody>tr>td[data-v-217ac0b1]{padding:.5rem 1rem}", ""]);
// Exports
module.exports = exports;
